import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { HttpParams, HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SettlementServiceService extends ApiService {

  // constructor() { }

  getBankStatistics(params: any): Observable<any>{
    return this.get<any>(ROUTES.BANK_STATS, {
      params: params
    })
  }

  getUnsettledRecords(params: any): Observable<any>{
    return this.get<any>(ROUTES.UNSETTLED_BANK_RECORDS, {
      params: params
    })
  }

  getAllBanks(type: string): Observable<any> {
    return this.get<any>(ROUTES.GET_ALL_BANKS, {
      params: {
        t: type,
      },
    });
  }
  uploadDocx(payload:any){
    return this.post<any>(ROUTES.SETTLEMENT_DOCUMENT_UPLOAD,{body:payload})
  }

  getMandirSettlementStats(params: any): Observable<any> {
    return this.get<any>(ROUTES.MANDIR_SETTLEMENT_STATS, { params });
  }

  getUnsettledMandir(params:any): Observable<any> {
    return this.get<any>(ROUTES.UNSETTLED_MANDIR, {
      params
    })
    
  }

  getWorkerDetails(params: any): Observable<any>{
    // const param = new HttpParams().set("mandircode", code);
    return this.get<any>(ROUTES.MANDIR_WORKER, {
      params
    })
  }

  getMandirBills(params: any): Observable<any>{
    return this.get<any>(ROUTES.MANDIR_BILLS, {
      params
    })
  }

  getAdvanceDetails(params: any): Observable<any>{
    return this.get<any>(ROUTES.MANDIR_ADVANCE_TAKEN, {
      params
    })
  }
}
